<template>
  <div id="app">
    <router-view/>
    <zjf-toaster></zjf-toaster>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    this.Common.addSPM(this.$route.query.spm);
  }
}
</script>

<style>
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue